import { render, staticRenderFns } from "./languageSettings.vue?vue&type=template&id=65e42e47&scoped=true"
import script from "./languageSettings.vue?vue&type=script&lang=js"
export * from "./languageSettings.vue?vue&type=script&lang=js"
import style0 from "./languageSettings.vue?vue&type=style&index=0&id=65e42e47&prod&scoped=true&lang=css"
import style1 from "./languageSettings.vue?vue&type=style&index=1&id=65e42e47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e42e47",
  null
  
)

export default component.exports